<template>
  <section class="app-cookie-policy-manager">
    <p class="cpm-description">
      You can choose not to allow some types of cookies below. Click on the different category headings to find out more
      and change our default settings.
    </p>

    <div class="cpm-options">
      <AppCookiePolicyManagerOption v-for="o in options" :key="o.id" v-model="o.value" v-bind="o" class="cpm-option" />
    </div>

    <AppButton class="cpm-btn-save" @click="handleSave">Save</AppButton>
  </section>
</template>

<script>
import AppCookiePolicyManagerOption from '@/components/AppCookiePolicyManagerOption.vue';
import AppButton from '@/components/AppButton.vue';

export default {
  name: 'AppCookiePolicyManager',
  components: { AppButton, AppCookiePolicyManagerOption },
  props: {
    options: {
      type: Array,
      required: true,
    },
  },
  computed: {
    settings() {
      return this.options.reduce((acc, option) => {
        if ('value' in option) {
          acc[option.id] = option.value;
        }
        return acc;
      }, {});
    },
  },
  methods: {
    handleSave() {
      this.$emit('save', this.settings);
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/variables-site/variables' as vars;

.app-cookie-policy-manager {
  .cpm-description {
    font-size: 14px;
    line-height: 1.5;
    color: vars.$c-dark-5b;
  }

  .cpm-options {
    margin: 12px 0 16px;
  }

  .cpm-option {
    padding: 20px 0;

    &:not(:last-child) {
      border-bottom: 1px solid vars.$c-gray-da;
    }
  }

  .cpm-btn-save {
    max-width: 244px;
    height: 42px;
    margin-left: auto;
    font-size: 14px;

    @media (min-width: vars.$tablet-break-point + 1) {
      height: 42px;
    }
  }
}
</style>
